<template>
  <sfs-base-table
    class="versions-table"
    :key="tableKey"
    :data-provider="$versionsAPI.getVersions"
    provider-key="versions"
    :columns="columns"
    :filters="filters"
    :current-page="currentPage"
    :per-page="perPage"
    :show-per-page="showPerPage"
  >
    <template #cell(user_id)="data">
      <div class="d-flex align-items-center">
        <user-avatar-badge
          :is-system="!data.item.user_id"
          :name="data.item.user && data.item.user.name"
          margin-class="mr-2"
        />
        <b-link
          v-if="data.item.user_id"
          :to="{ name: 'user', params: { id: data.item.user_id } }"
        >
          {{ data.item.user.name }}
        </b-link>
        <span v-else>System</span>
      </div>
    </template>
    <template #cell(model)="data">
      <b-link
        v-if="findRoute(data.item.model)"
        :to="{ name: findRoute(data.item.model), params: { id: data.item.model_id } }"
      >
        {{ modelLabel(data.item) }}
      </b-link>
      <span v-else>{{ modelLabel(data.item) }}</span>
    </template>
    <template #cell(event)="data">
      <b-badge
        :variant="eventVariant(data.item.event)"
        class="versions-table__event-badge status-badge font-size-sm mr-1"
      >
        <i
          v-if="eventIcon(data.item.event)"
          class="fa mr-1"
          :class="eventIcon(data.item.event)"
        />
        {{ data.item.event | capitalizeFormat }}
      </b-badge>
    </template>
    <template #cell(created_at)="data">
      <span
        v-b-tooltip.hover
        :title="data.item.created_at | dateTimeFormat"
      >
        {{ data.item.created_at | dateOrTimeFormat }}
      </span>
    </template>

    <template #cell(changes)="data">
      <b-button
        v-b-modal="`version-changes-${data.item.id}-modal`"
        size="sm"
        variant="link"
      >
        <i class="fa fa-eye" />
      </b-button>
      <version-changes-modal v-model="data.item" />
    </template>
  </sfs-base-table>
</template>

<script>
import tablePropsMixin from '@/mixins/tablePropsMixin';
import {
  VERSION_TABLE_DEFAULT_COLUMNS,
  VERSION_MODEL_ROUTES,
  VERSION_MODEL_NAMES,
  VERSION_EVENT_VARIANTS,
  VERSION_EVENT_ICONS,
} from '@/constants/versions';

import VersionChangesModal from '@/components/admin/versions/ChangesModal';
import UserAvatarBadge from '@/components/shared/users/UserAvatarBadge.vue';

export default {
  name: 'VersionsTable',
  components: {
    VersionChangesModal,
    UserAvatarBadge,
  },
  mixins: [tablePropsMixin],
  props: {
    columns: {
      type: Array,
      default: () => VERSION_TABLE_DEFAULT_COLUMNS,
    },
  },
  methods: {
    findRoute(model) {
      return VERSION_MODEL_ROUTES[model];
    },
    modelLabel(version) {
      return `${VERSION_MODEL_NAMES[version.model]} ${version.model_id}`;
    },
    eventVariant(event) {
      return VERSION_EVENT_VARIANTS[event] || 'secondary';
    },
    eventIcon(event) {
      return VERSION_EVENT_ICONS[event] || null;
    },
  },
};
</script>
